module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n    form.migrate-form hr {\r\n        margin: 0;\r\n    }\r\n    form.migrate-form span.header {\r\n        font-weight: bold;\r\n    }\r\n    form.migrate-form span.separator {\r\n        margin-right: 10px;\r\n    }\r\n    form.migrate-form .indented {\r\n        padding-left: 20px;\r\n        padding-top: 5px;\r\n    }\r\n    form.migrate-form select.version {\r\n        width: 60px;\r\n        height: 17px;\r\n        font-size: 0.9em;\r\n    }\r\n</style>\r\n<div id=\"dialog\" title=\"Migrate\" style=\"display: none;\">\r\n   \r\n    <form class=\"migrate-form form-horizontal\">\r\n        ")
    ;  if(warning){ 
    ; __append("\r\n            <i class=\"fa pf-warning\" style=\"font-size:30px\"></i>\r\n            <div style=\"padding: 10px 0\"> \r\n                This import will replace the connection permanently. The previous connection cannot be recovered.\r\n                <br><br>\r\n                Would you like to download a backup before replacing the current connection?\r\n            </div>\r\n        ")
    ;  }else {
    ; __append("\r\n        <div class=\"container-fluid\">\r\n            <div class=\"row\">\r\n                <span class=\"header\">Import</span>\r\n                <hr />\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"radio\">\r\n                    <label>\r\n                        <input type=\"radio\" name=\"action\" value=\"import\" class=\"action-selector\">\r\n                        (Type) Connection\r\n                    </label>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <span class=\"header\">Export</span>\r\n                <hr />\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"radio\">\r\n                    <label>\r\n                        <input type=\"radio\" name=\"action\" value=\"export\" class=\"action-selector\">\r\n                        (Type) Connection\r\n                    </label>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        ")
    ;  }
    ; __append("\r\n    </form>\r\n   \r\n</div>")
  }
  return __output;

}